// extracted by mini-css-extract-plugin
module.exports = {"_arrow-style":"ArrowStyle__arrow-style_3gLgm relative b--green"};